const amountOfBrandProfilesOnPage = 50;

export default amountOfBrandProfilesOnPage;
